import { PeriodSelect, PeriodSelectorPanel } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React, { useMemo, useState } from 'react';

import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import { useHomeActions } from '../../../../store/home/capture/actions';
import {
  selectedAccountsPerformanceYearState,
  yearsState,
} from '../../../../store/home/capture/atom';

import { Cohort } from './components/Cohort';
import { QualificationsContent } from './components/QualificationsContent';

export namespace AccountPerformancesTypes {
  export interface Props {
    isMobile?: boolean;
  }
}

export const AccountPerformances: React.FC<AccountPerformancesTypes.Props> = ({ isMobile }) => {
  const [selectedViewOption, setSelectedViewOption] = useState('qualifications');
  const { setSelectedAccountsPerformanceYear } = useHomeActions();
  const { data: yearSelected } = useRecoilQuery(selectedAccountsPerformanceYearState);
  const { data: years } = useRecoilQuery(yearsState);

  const content = useMemo(() => {
    switch (selectedViewOption) {
      case 'qualifications':
        return <QualificationsContent isMobile={isMobile} />;
      case 'cohort':
        return <Cohort isMobile={isMobile} />;
      default:
        return null;
    }
  }, [isMobile, selectedViewOption, yearSelected]);

  const onViewChange = (value: string) => {
    setSelectedViewOption(value);
  };

  return (
    <PeriodSelectorPanel
      flex={1}
      fullWidth
      title="DESEMPENHO DE CONTAS"
      onPeriodChange={setSelectedAccountsPerformanceYear}
      options={years?.map((year) => ({ label: year, value: year })) || []}
      optionsEnabled={selectedViewOption !== 'cohort'}
      testId="customers-activation-panel"
      selectedOption={yearSelected || ''}
      titleCustomProps={{ fontSize: Typography['fontsize.lg'] }}
      isMobile={isMobile}
      minHeight="fit-content"
      customOptionsComponent={
        <PeriodSelect
          label="Selecione uma opção"
          periodOptions={[
            { label: 'HABILITAÇÕES', value: 'qualifications' },
            { label: 'COHORT DE CONVERSÃO', value: 'cohort' },
          ]}
          selectedPeriod={selectedViewOption}
          p={0}
          pr="8px"
          onPeriodChange={onViewChange}
        />
      }>
      {content}
    </PeriodSelectorPanel>
  );
};
